import Vue from 'vue';
import Vuex from 'vuex';
import gql from 'graphql-tag';

Vue.use(Vuex);

Vue.localStorage.wishlistProducts = {
    type: Array,
    default: []
};

export default new Vuex.Store({
    state() {
        let products;
        try {
            products = JSON.parse(Vue.localStorage.get('wishlistProducts'));
        } catch (e) {
            console.log(e);
            products = [];
        }
        if (!Array.isArray(products)) {
            products = [];
        }

        return {
            wishlistProducts: products
        };
    },
    mutations: {
        setWishlistProducts(state, products) {
            if (products && Array.isArray(products)) {
                state.wishlistProducts = products;
                Vue.localStorage.set('wishlistProducts', JSON.stringify(products));
            }
        }
    },
    actions: {
        loadWishlistProducts({ state, commit, dispatch }) {
            if (Vue.$store.getters['Login/isUserLoggedIn']) {
                Vue.$graphql
                    .query({
                        query: gql`
                            query getCustomerWishlist {
                                getCustomerWishlist {
                                    items {
                                        id
                                    }
                                }
                            }
                        `,
                        fetchPolicy: 'no-cache'
                    })
                    .then(r => r.data.getCustomerWishlist)
                    .then(result => {
                        const items = {};
                        if (state.wishlistProducts.length) {
                            state.wishlistProducts.forEach(item => {
                                items[item.id] = item;
                            });
                        }
                        if (result.items && result.items.length) {
                            result.items.forEach(item => {
                                items[item.id] = item;
                            });
                        }
                        const mergedItems = Object.values(items);
                        dispatch('saveWishlist', mergedItems);
                        commit('setWishlistProducts', mergedItems);
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
        },
        addWishlistProduct({ state, commit, dispatch }, productId) {
            const items = state.wishlistProducts;
            let itemExists = false;
            items.some(item => {
                itemExists = item.id == productId;
                return itemExists;
            });
            if (!itemExists) {
                items.push({
                    id: productId.toString()
                });
            }

            return new Promise(resolve => {
                commit('setWishlistProducts', items);
                dispatch('saveWishlist', items);
                resolve({
                    success: true,
                    action: 'add'
                });
            });
        },
        removeWishlistProduct({ state, commit, dispatch }, productId) {
            const items = state.wishlistProducts;
            items.forEach((item, index) => {
                if (item.id == productId) {
                    items.splice(index, 1);
                }
            });
            return new Promise(resolve => {
                commit('setWishlistProducts', items);
                dispatch('saveWishlist', items);
                resolve({
                    success: true,
                    action: 'remove'
                });
            });
        },
        saveWishlist({}, items) {
            if (Vue.$store.getters['Login/isUserLoggedIn']) {
                Vue.$graphql
                    .mutate({
                        mutation: gql`
                            mutation($wishlist: WishlistInput!) {
                                saveCustomerWishlist(wishlist: $wishlist) {
                                    items {
                                        id
                                    }
                                }
                            }
                        `,
                        variables: {
                            wishlist: {
                                items: items
                            }
                        },
                        fetchPolicy: 'no-cache'
                    })
                    .catch(err => console.log(err));
            }
        }
    }
});
